import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('VehicleService', VehicleService);

  VehicleService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    'UtilService',
    'SessionService',
    'TranslationModalService',
    'UploadService',
    '$cacheFactory',
  ];

  function VehicleService(
    RestResource,
    config,
    $translate,
    UtilService,
    SessionService,
    TranslationModalService,
    UploadService,
    $cacheFactory
  ) {
    let utils = new UtilService(this);

    let apiUrl = environment.apiEndpoint + 'vehicles';

    let cache = $cacheFactory('vehiclesCache');

    let service = {
      getFilterCriteria: getFilterCriteria,
      getVehicles: getVehicles,
      getVehicle: getVehicle,
      saveVehicle: saveVehicle,
      openVehicleTranslations: openVehicleTranslations,
      openLogo: openLogo,
      updateLogo: updateLogo,
      deleteVehicle: deleteVehicle,
      changeVehicleStatus: changeVehicleStatus,
      hasVehiclesCache: hasVehiclesCache,
      getVehiclesCache: getVehiclesCache,
      setVehiclesCache: setVehiclesCache,
      clearVehiclesCache: clearVehiclesCache,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      let filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function getVehicles(filterCriteria, companyId) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = companyId || SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: utils.cleanItemsCache(response.data, 'logo'),
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getVehicle(id, language, translate) {
      var params = { lang: null, get: null };

      if (language) {
        params.lang = language;
      }

      if (translate) {
        params.get = 'translate';
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        params,
        function (response) {
          response.data.logoUrl = utils.cleanItemCache(response.data, 'logo');
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveVehicle(item, language, cropedImage) {
      let method;
      let url = apiUrl;

      if (!item.id) {
        // create
        method = 'post';
        item.company_id = SessionService.getSelectedAccountCompany().id;
      } else {
        method = 'put';
        url = url + '/' + item.id;
      }

      let lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;

      url = url + '?lang=' + lang;

      return UploadService.uploadFile(
        method,
        url,
        'vehicle',
        item,
        cropedImage,
        function () {},
        function (response) {
          let msg = !item.id ? 'NEW_ADDED_VEHICLE' : 'MODIFIED_VEHICLE';
          utils._successMsg($translate.instant(msg));

          if (!item.id) {
            // Create
            let itemAddedFlashMsg =
              $translate.instant('VEHICLE_ADDED_MSG') +
              ' ' +
              $translate.instant('REMEMBER_ADD_TRANSLATIONS');
            utils._setFlashMessage(itemAddedFlashMsg);
          }

          clearVehiclesCache();

          return response;
        },
        function () {}
      );
    }

    function openVehicleTranslations(item, additionalLanguages) {
      let template = './app/ajs/vehicles/modals/vehicle-detail-translation.html';

      let modalParams = {
        title: item.name,
        item: item,
        additionalLanguages: additionalLanguages,
      };

      let initializeCallback = function (itemId, language) {
        return getVehicle(itemId, language, 'translate').then(function (data) {
          return data;
        });
      };

      let confirmCallback = function (item, language) {
        return saveVehicle(item, language, '').then(
          function () {
            return false;
          },
          function (response) {
            return response.data;
          }
        );
      };

      TranslationModalService.open(template, modalParams, initializeCallback, confirmCallback);
    }

    function openLogo(item, saveLogoCallBack) {
      utils.openLogo(item, saveLogoCallBack);
    }

    // Update logo after crop
    function updateLogo(item, cropedImage) {
      let url = apiUrl + '/' + item.id + '?lang=' + config.DEFAULT_CONTENT_LANGUAGE;

      utils.updateLogo(url, 'vehicle', item, cropedImage);
    }

    function deleteVehicle(item, successCallback) {
      let params = {
        title: 'DELETE_VEHICLE',
        itemName: item.name,
        reason: 'DELETE_ITEM_REASON',
        confirmButtonLabel: 'DELETE_VEHICLE',
        successMsg: 'DELETED_VEHICLE',
      };

      let url = apiUrl + '/' + item.id;
      utils.deleteItem(url, successCallback, params);
    }

    function changeVehicleStatus(item) {
      utils.changeItemStatus(apiUrl + '/' + item.id, item);
    }

    function hasVehiclesCache() {
      return cache.get('all') !== undefined;
    }

    function getVehiclesCache() {
      return cache.get('all');
    }

    function setVehiclesCache(vehicles) {
      cache.put('all', vehicles);
    }

    function clearVehiclesCache() {
      cache.removeAll();
    }
  }
})();
